import { render } from "./ShareSelectEntityModal.vue?vue&type=template&id=650740a2"
import script from "./ShareSelectEntityModal.vue?vue&type=script&lang=js"
export * from "./ShareSelectEntityModal.vue?vue&type=script&lang=js"

import "./ShareSelectEntityModal.vue?vue&type=style&index=0&id=650740a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__